import React from 'react';

const BLOCK_TAGS = {
  blockquote: 'block-quote',
  p: 'paragraph',
  pre: 'code',
  li: 'list-item',
  ol: 'numbered-list',
  ul: 'bulleted-list',
  h2: 'heading-two',
  h3: 'heading-three',
  code: 'code',
};
const INLINE_TAGS = {
  a: 'link',
  span: 'emoji',
};


// Add a dictionary of mark tags.
const MARK_TAGS = {
  em: 'italic',
  code: 'code',
  strong: 'bold',
  u: 'underlined',
};

const rules = [
  {
    deserialize(el, next) {
      const type = BLOCK_TAGS[el.tagName.toLowerCase()];
      if (!type) return;
      return {
        object: 'block',
        type: type,
        nodes: next(el.childNodes),
      };
    },
    serialize(obj, children) {
      if (obj.object !== 'block') return;
      switch (obj.type) {
        case 'code':
          return (
            <pre>
              <code>{children}</code>
            </pre>
          );
        case 'paragraph':
          return <p>{children}</p>;
        case 'block-quote':
          return <blockquote>{children}</blockquote>;
        case 'bulleted-list':
          return <ul>{children}</ul>;
        case 'heading-two':
          return <h2>{children}</h2>;
        case 'heading-three':
          return <h3>{children}</h3>;
        case 'list-item':
          return <li>{children}</li>;
        case 'numbered-list':
          return <ol>{children}</ol>;
        default:
          return ``;
      }
    },
  },
  // Add a new rule that handles marks...
  {
    deserialize(el, next) {
      const type = MARK_TAGS[el.tagName.toLowerCase()];
      if (!type) return;
      return {
        object: 'mark',
        type: type,
        nodes: next(el.childNodes),
      };
    },
    serialize(obj, children) {
      if (obj.object !== 'mark') return;
      switch (obj.type) {
        case 'bold':
          return <strong>{children}</strong>;
        case 'italic':
          return <em>{children}</em>;
        case 'code':
          return <code>{children}</code>;
        case 'underlined':
          return <u>{children}</u>;
        default:
          return '';
      }
    },
  },
  {
    deserialize: function(el, next) {
      if (!el.tagName || el.tagName.toLowerCase() !== 'a'|| el.tagName.toLowerCase()==='span') {

        return;
      }
      const type = INLINE_TAGS[el.tagName.toLowerCase()];

      if (!type) {
        return;
      }
      console.log(el.getAttribute('href'));
      return {
        kind: 'inline',
        type: type,
        nodes: next(el.childNodes),
        data: {
          href: el.getAttribute('href'),
        },
      };
    },
    serialize: function(object, children) {
      if (object.kind !== 'inline') {
        return;
      }

      switch (object.type) {
        case 'link':
          console.log(object.data.get('href'));
          return <a href={object.data.get('href')}>{children}</a>;
        case 'emoji':
          return (
            <span className={`emoji`} contentEditable={false}>
              {object.data.get('code')}
            </span>
          );
        default:
          return null;
      }
    },
  },
];


export default rules;



// WEBPACK FOOTER //
// ./src/arkulpa-fec/components/ArkEdit/convertHtmlRules.js